import * as yup from "yup";

import { ERRORS_MESSAGE } from "@bms/constants";

export const validation = (id: string | null | undefined) => {
  return yup.object().shape({
    // ...(!id && {
    //   number_id: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
    // }),
    name: yup
      .string()
      .nullable()
      .required(ERRORS_MESSAGE["REQUIRED"])
      .max(50, "氏名は50文字以内で入力してください。"),
    role: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
    ...(!id && {
      login_pass: yup
        .string()
        .nullable()
        .required(ERRORS_MESSAGE["REQUIRED"])
        .min(6, `6 ${ERRORS_MESSAGE["MIN"]}`),
    }),
    phone_number: yup
      .string()
      .nullable()
      .test(
        "phone-length",
        ERRORS_MESSAGE["PHONE_NUNBER_INVALID"],
        function (value) {
          if (!value) return true;
          return value.length >= 10 && value.length <= 13;
        }
      ),
  });
};
